import { Role } from '@/common/model/types';
import { AppRoutes } from '@/app/routes/app_routes';
import type { GuidedTour } from '../types';

export const createTeamTour: GuidedTour = {
  id: 'create-team',
  roles: [Role.COACH, Role.CLUB_ADMIN, Role.SUPER_ADMIN],
  steps: [
    {
      id: 'team-create',
      titleKey: 'tours.create_team.create.title',
      descriptionKey: 'tours.create_team.create.description',
      targetSelector: '[data-onboarding="team-create-button"]',
      placement: 'bottom',
      route: AppRoutes.team.list,
      order: 0,
    },
    {
      id: 'team-open',
      titleKey: 'tours.create_team.open.title',
      descriptionKey: 'tours.create_team.open.description',
      targetSelector: '[data-onboarding="team-list"]',
      placement: 'top',
      route: AppRoutes.team.list,
      order: 1,
    },
    {
      id: 'team-season',
      titleKey: 'tours.create_team.season.title',
      descriptionKey: 'tours.create_team.season.description',
      targetSelector: '[data-onboarding="season-selector"]',
      placement: 'right',
      order: 2,
    },
    {
      id: 'team-end',
      titleKey: 'tours.create_team.end.title',
      descriptionKey: 'tours.create_team.end.description',
      targetSelector: '',
      placement: 'center',
      order: 3,
    },
  ],
};
